module.exports = __webpack_public_path__ + "img/stick_hebergements_residence_tourisme.8e2ffa06.svg";